var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "speechBox"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showSetting,
      expression: "!showSetting"
    }],
    staticClass: "speechContext"
  }, [_c('div', {
    attrs: {
      "id": "lottie"
    }
  }), _c('div', {
    staticClass: "head"
  }, [_c('el-button', {
    staticClass: "summaryBtn",
    attrs: {
      "loading": _vm.summaryLoading,
      "size": "medium"
    },
    on: {
      "click": function ($event) {
        return _vm.createSummary();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('aiSpeech.aiSummary')))]), _c('el-divider', {
    staticClass: "gray",
    attrs: {
      "direction": "vertical"
    }
  }), _c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": _vm.$t('commonPartyHost.topContent.send')
    }
  }, [_vm.userInfo.owner ? _c('i', {
    staticClass: "iconfont icon-xingzhuang pointer",
    on: {
      "click": function ($event) {
        _vm.sendEmailInfo.show = true;
      }
    }
  }) : _vm._e()]), _c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": _vm.$t('commonPartyHost.topContent.copy')
    }
  }, [_c('i', {
    staticClass: "iconfont icon-log pointer",
    on: {
      "click": _vm.copyMessage
    }
  })]), _c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": _vm.$t('aiSpeech.download')
    }
  }, [_c('i', {
    staticClass: "iconfont icon-xiazai pointer",
    on: {
      "click": _vm.downloadTxt
    }
  })]), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "popper-class": "translateSetting",
      "width": "260",
      "trigger": "click"
    },
    model: {
      value: _vm.showTranslate,
      callback: function ($$v) {
        _vm.showTranslate = $$v;
      },
      expression: "showTranslate"
    }
  }, [_c('div', {
    staticClass: "translate"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('aiSpeech.translateInto')))]), _c('el-radio-group', {
    model: {
      value: _vm.translateInto,
      callback: function ($$v) {
        _vm.translateInto = $$v;
      },
      expression: "translateInto"
    }
  }, _vm._l(_vm.langArray, function (lang) {
    return _c('el-radio', {
      key: lang.val,
      staticClass: "green",
      attrs: {
        "label": lang.val
      }
    }, [_vm._v(_vm._s(lang.label))]);
  }), 1)], 1), _c('el-tooltip', {
    attrs: {
      "slot": "reference",
      "placement": "top",
      "content": _vm.$t('aiSpeech.translate')
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "iconfont icon-translate pointer",
    style: {
      color: _vm.showTranslate ? '#33AB4F' : ''
    }
  })])], 1), _c('el-divider', {
    staticClass: "gray",
    attrs: {
      "direction": "vertical"
    }
  }), _c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": _vm.$t('setting.settingName')
    }
  }, [_c('i', {
    staticClass: "el-icon-setting pointer",
    on: {
      "click": _vm.showSpeechSetting
    }
  })])], 1), _c('el-divider', {
    staticClass: "bottom"
  }), _c('div', {
    ref: "content",
    staticClass: "content scrollbar",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_vm._l(_vm.voiceContent, function (item, index) {
    return _c('div', {
      key: index,
      ref: 'msgBoxRef' + index,
      refInFor: true,
      staticClass: "msgBox"
    }, [_c('div', {
      staticClass: "top"
    }, [_c('div', {
      staticClass: "topLeft"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.behaviorInfo[item.uid]))]), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.userInfo.rtilCode == item.uid,
        expression: "userInfo.rtilCode == item.uid"
      }],
      staticClass: "tips"
    }, [_vm._v("(" + _vm._s(_vm.$t('aiSpeech.me')) + ")")]), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm.formatTimeToAMPM(item.time)))])])]), _c('div', {
      staticClass: "msg"
    }, [_c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.content))]), item.translateContent ? _c('el-divider', {
      staticClass: "translateDivder"
    }) : _vm._e(), item.translateContent ? _c('div', [_vm._v(_vm._s(item.translateContent))]) : _vm._e()], 1), item.showDivider ? _c('div', {
      staticClass: "dividerContent"
    }, [_c('el-divider'), _c('span', [_vm._v("New")])], 1) : _vm._e()]);
  }), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showScrollTopBtn,
      expression: "showScrollTopBtn"
    }],
    staticClass: "iconfont icon-a-backtobottom",
    on: {
      "click": _vm.scrollToBottom
    }
  })], 2), _c('div', {
    staticClass: "foot"
  }, [_c('speechBar')], 1)], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSetting,
      expression: "showSetting"
    }],
    staticClass: "speechSetting"
  }, [_c('div', {
    staticClass: "settingHead"
  }, [_c('i', {
    staticClass: "el-icon-back pointer",
    on: {
      "click": _vm.closeSpeechSetting
    }
  }), _c('el-divider', {
    staticClass: "gray",
    attrs: {
      "direction": "vertical"
    }
  }), _c('span', {
    staticClass: "settingTitle"
  }, [_vm._v(_vm._s(_vm.$t('setting.settingName')))])], 1), _c('el-divider', {
    staticClass: "bottom"
  }), _c('div', {
    staticClass: "settingContent"
  }, [_c('div', {
    staticClass: "sourceType"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t('kioskHost.sourceType')) + " "), _c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": _vm.$t('aiSpeech.helpTips')
    }
  }, [_c('i', {
    staticClass: "iconfont icon-help2"
  })])], 1), _c('el-checkbox-group', {
    model: {
      value: _vm.scourceTypeVal,
      callback: function ($$v) {
        _vm.scourceTypeVal = $$v;
      },
      expression: "scourceTypeVal"
    }
  }, _vm._l(_vm.sourceTypeArray, function (lang) {
    return _c('el-checkbox', {
      key: lang.val,
      staticClass: "green",
      attrs: {
        "label": lang.val
      }
    }, [_vm._v(_vm._s(_vm.$t(`aiSpeech.${lang.label}`)))]);
  }), 1)], 1)])], 1), _c('tipsDailog', {
    staticClass: "sendEmail",
    attrs: {
      "info": _vm.sendEmailInfo,
      "width": "640px"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "headTitle"
  }, [_vm._v(_vm._s(_vm.$t('common.sendSetting')))]), _c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": _vm.$t('setting.settingName')
    }
  }, [_c('i', {
    staticClass: "iconfont tvu-icon-a-help1 pointer",
    on: {
      "click": _vm.showSpeechSetting
    }
  })])], 1), _c('div', {
    staticClass: "content"
  }, _vm._l(_vm.emailList, function (item) {
    return _c('div', {
      key: item.title,
      staticClass: "emailLi"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('span', {
      staticClass: "emailTitle"
    }, [_vm._v(_vm._s(_vm.$t(`aiSpeech.${item.title}`)))]), _c('el-tooltip', {
      attrs: {
        "placement": "top"
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.returnEmailTips(item.title))
      },
      slot: "content"
    }), _c('i', {
      staticClass: "iconfont icon-help2"
    })])], 1), _vm.sendEmailInfo.show ? _c('emailInput', {
      attrs: {
        "partyCode": _vm.userInfo.joinCode,
        "type": item.title
      },
      on: {
        "addEmail": _vm.addEmail,
        "deleteEmail": _vm.deleteEmail
      },
      model: {
        value: item.value,
        callback: function ($$v) {
          _vm.$set(item, "value", $$v);
        },
        expression: "item.value"
      }
    }) : _vm._e()], 1);
  }), 0), _c('div', {
    staticClass: "emailFoot",
    attrs: {
      "slot": "foot"
    },
    slot: "foot"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSavingTips,
      expression: "showSavingTips"
    }],
    staticClass: "emailText"
  }, [_vm._v(_vm._s(_vm.returnSavingEmailText))]), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.closeEmail
    }
  }, [_vm._v(_vm._s(_vm.$t('Movepips.done')))]), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v(_vm._s(_vm.$t('commonPartyHost.topContent.send')))])], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };